// src/services/Pdf.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfNatureProduction {
  static async gerarRelatorio(
    distrito,
    categoria,
    subcategoria,
    natureza,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
    naturezaImage,
    mapImage2
  ) {
    const doc = new jsPDF();
    const inscricao = null;
    const proprietario = null;

    if (natureza === "todos") {
      natureza = null;
    }

    if (areaMin === "") {
      areaMin = null;
    }

    if (areaMax === "") {
      areaMax = null;
    }

    if (prodMin === "") {
      prodMin = null;
    }

    if (prodMax === "") {
      prodMax = null;
    }

    const propriedades = await Api.getNumeroPropriedades(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );
    const dadosNatureza = await Api.getNaturezaProd(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );
    const dadosProducao = await Api.getContarProducao(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );
    const areaMedia = await Api.getAreaMedia(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );
    const producao = await Api.getProducaoEmKg(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );
    const producaoMedia = await Api.getProducaoMedia(
      distrito,
      categoria,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax
    );

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);

    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);
    const unidade = dadosProducao[0].unidade;

    let y = 120;
    const filtros = [
      ["Inscrição/Código da Propriedade:  ", "Não informado"],
      ["Nome do Proprietário: ", "Não informado"],
      ["Distrito:", distrito || "Não informado"],
      ["Categoria de Produção: ", categoria || "Não informado"],
      ["Subcategoria de Produção: ", subcategoria || "Não informado"],
      ["Natureza de Produção: ", natureza || "Todas"],
      ["Área Mínima da Propriedade (ha): ", areaMin || "  -  "],
      ["Área Máxima da Produção (ha): ", areaMax || "  -  "],
      [`Quantidade Mínima Produzida (${unidade}): `, prodMin || "  -  "],
      [`Quantidade Máxima Produzida (${unidade}): `, prodMax || "  -  "],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades Cadastradas:   ", propriedades.value],
      ["Área Média (ha):  ", areaMedia.value.toFixed(2)],
      [`Produção (${unidade}):  `, producao.value],
      [`Produção Média (${unidade}):  `, producaoMedia.value.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    // Natureza de Produção
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Natureza de Produção", 10, y);

    y += 10;

    const comercialPercent =
      (dadosNatureza.value["01 - Comercial"] / propriedades.value) * 100.0;
    const subsistenciaPercent =
      (dadosNatureza.value["02 - Subsistência"] / propriedades.value) * 100.0;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    if (subcategoria && subcategoria !== "todas") {
      doc.text(
        `      O gráfico exibido ao lado demonstra que ${
          dadosNatureza.value["01 - Comercial"]
        } (${comercialPercent.toFixed(2)}%) das ${
          propriedades.value
        } propriedades de ${subcategoria.toLowerCase()} apresentam natureza de produção COMERCIAL, enquanto ${
          dadosNatureza.value["02 - Subsistência"]
        } (${subsistenciaPercent.toFixed(2)}%) são de SUBSISTÊNCIA.`,
        10,
        y,
        { maxWidth: 100, align: "justify" }
      );
    } else {
        doc.text(
          `      O gráfico exibido ao lado demonstra que ${
            dadosNatureza.value["01 - Comercial"]
          } (${comercialPercent.toFixed(2)}%) das ${
            propriedades.value
          } propriedades de ${categoria.toLowerCase()} apresentam natureza de produção COMERCIAL, enquanto ${
            dadosNatureza.value["02 - Subsistência"]
          } (${subsistenciaPercent.toFixed(2)}%) são de SUBSISTÊNCIA.`,
          10,
          y,
          { maxWidth: 100, align: "justify" }
        );
    }

    doc.addImage(naturezaImage, "PNG", 120, y, 80, 60);

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    y = 40;

    doc.text("Mapa de propriedades", 10, y);

    y += 5;

    doc.addImage(mapImage2, 10, y, 150, 100);

    y += 110;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    let propriedadesText = `      No mapa acima podemos ter uma noção visual da localização das propriedades que possuem ${categoria.toLowerCase()}. Os desenhos de CASA representam natureza de subsistência e os de LOJA representam comércio.`;

    if (subcategoria && subcategoria !== "todas") {
      propriedadesText = `      No mapa acima podemos ter uma noção visual da localização das propriedades que possuem ${subcategoria.toLowerCase()}. Os desenhos de CASA representam natureza de subsistência e os de LOJA representam comércio.`;
    }

    doc.text(propriedadesText, 10, y, { maxWidth: 190 });

    y += 20;

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    doc.text("Tabela de contagem de cultura", 10, y);

    y += 10;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    let tabelaText = `      A Tabela abaixo lista as culturas associadas a ${categoria.toLowerCase()}, sendo a coluna cultura representando o nome da produção, natureza a contagem de propriedades que produzem, produção o valor total produzido e a coluna que representa a unidade`;

    doc.text(tabelaText, 10, y, { maxWidth: 190 });

    y += 15;
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    // Dados da tabela
    const colunas = ["Cultura", "Natureza", "Produção", "Unidade"];
    const linhas = dadosProducao.map((item) => [
      item.cultura,
      item.natureza,
      item.producao,
      item.unidade,
    ]);

    // Gerar tabela
    autoTable(doc, {
      head: [colunas],
      body: linhas,
      startY: y, // onde a tabela começa no eixo Y
      styles: {
        fontSize: 12,
        halign: "center", // alinhamento do texto
        valign: "middle",
      },
      headStyles: {
        fillColor: [175, 133, 0], // cor do cabeçalho
        textColor: 255,
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // cor alternada
      },
    });

    const fileName =
      "Relatorio_NaturezaProducao_" +
      distrito +
      "_" +
      categoria +
      "_" +
      this.dataAtual() +
      ".pdf";
    doc.save(fileName);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de produção sobre as propriedades",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" }
    );
    doc.text(
      "rurais cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" }
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfNatureProduction;
